module.exports = __webpack_public_path__ + "img/68.faf51620.jpg";